import { HeatmapContainer } from '@/components/heatmaps/HeatmapContainer'
import DemoSiteBanner from '@/components/shared/DemoSiteBanner'
import { FeatureGate } from '@/components/shared/FeatureGate'
import { useOutletContext } from 'react-router-dom'

interface DashboardContext {
  dashboardData: any
  isLoading: boolean
  propertyId?: string
  property?: any
}

export default function Heatmaps() {
  const context = useOutletContext<DashboardContext>()

  return (
    <div className="flex min-h-full flex-col">
      {/* The heatmap body bleeds to the panel edges; this margin absorbs its
          negative top margin when the demo banner is showing. */}
      <div className="mb-5 empty:hidden sm:mb-7">
        <DemoSiteBanner propertyId={context.propertyId} />
      </div>
      <FeatureGate feature="heatmaps">
        <HeatmapContainer />
      </FeatureGate>
    </div>
  )
}
